import { render, staticRenderFns } from "./CategoryPreviewModal.vue?vue&type=template&id=c227b454&scoped=true"
import script from "./CategoryPreviewModal.vue?vue&type=script&lang=js"
export * from "./CategoryPreviewModal.vue?vue&type=script&lang=js"
import style0 from "./CategoryPreviewModal.vue?vue&type=style&index=0&id=c227b454&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c227b454",
  null
  
)

export default component.exports